import script from "./CommingSoon.vue?vue&type=script&setup=true&lang=js"
export * from "./CommingSoon.vue?vue&type=script&setup=true&lang=js"

import "./CommingSoon.vue?vue&type=style&index=0&id=4256ffe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4256ffe4"]])

export default __exports__